import React, { useState, useEffect, useContext, lazy, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { CChartLine } from '@coreui/react-chartjs';
import {
  CButton,
  CButtonGroup,
  CButtonToolbar,
  CCard,
  CCardBody,
  CCardTitle,
  CCol,
  CRow,
} from '@coreui/react';
//import { FirebaseContext, withFirebase } from '../../firebase';
import { getStyle, hexToRgba } from '@coreui/utils';

//const Widget03 = lazy(() => import('../../../views/Widgets/Widget03'));

const brandPrimary = getStyle('--primary');
const brandSuccess = getStyle('--success');
const brandInfo = '#0080FF'; // Fallback color;
const brandWarning = getStyle('--warning');
const brandDanger = getStyle('--danger');

const Social = () => (
  <div>
    <SocialForm />
  </div>
);

const SocialBase = (props) => {
  const [users, setUsers] = useState([]);
  const [date, setDate] = useState(new Date().toISOString());
  //const firebase = useContext(FirebaseContext);
  const [radioSelected, setRadioSelected] = useState(1);
  
  const onRadioBtnClick = (btnIndex) => {
    setRadioSelected(btnIndex);
  };
 

  const usersSampleData = [
    { date: '2024-07-01', calories: 500 },
    { date: '2024-07-02', calories: 450 },
    { date: '2024-07-03', calories: 600 },
    { date: '2024-07-04', calories: 700 },
    { date: '2024-07-05', calories: 400 },
    { date: '2024-07-06', calories: 550 },
    { date: '2024-07-07', calories: 650 },
  ];
  const labels = users.map(user => usersSampleData.date);
  const dataVals = users.map(user => usersSampleData.calories);

  const mainChart = {
    labels: labels,
    datasets: [
      {
        label: 'Social Activity',
        backgroundColor: hexToRgba(brandInfo, 10),
        borderColor: brandInfo,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: dataVals,
      },
    ],
  };

  const mainChartOpts = {
    tooltips: {
      enabled: true,
      intersect: true,
      mode: 'index',
      position: 'nearest',
      callbacks: {
        labelColor: function (tooltipItem, chart) {
          return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor };
        },
      },
    },
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scale: {
      ticks: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div>
      <CRow>
        <CCol>
          <CCard>
            <CCardBody>
              <CRow>
                <CCol sm="5">
                  <CCardTitle className="mb-0">Social</CCardTitle>
                  <div className="small mb-2">Last refreshed: {date}</div>
                </CCol>
                <CCol sm="7" className="d-none d-sm-inline-block">
                  <CButton color="primary" className="float-right"><i className="icon-cloud-download"></i></CButton>
                  <CButtonToolbar className="float-right" aria-label="Toolbar with button groups">
                    <CButtonGroup className="mr-3" aria-label="First group">
                      <CButton color="outline-secondary" onClick={() => onRadioBtnClick(1)} active={radioSelected === 1}>Day</CButton>
                      <CButton color="outline-secondary" onClick={() => onRadioBtnClick(2)} active={radioSelected === 2}>Month</CButton>
                      <CButton color="outline-secondary" onClick={() => onRadioBtnClick(3)} active={radioSelected === 3}>Year</CButton>
                    </CButtonGroup>
                  </CButtonToolbar>
                </CCol>
              </CRow>
              <div className="chart-wrapper" style={{ height: 300 + 'px', marginTop: 40 + 'px' }}>
                <CChartLine data={mainChart} options={mainChartOpts} height={300} />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
};

const SocialForm = SocialBase;

export default Social;
export { SocialForm };


